import React from 'react';

import { Skeleton } from 'native-base';
import { StyleSheet } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import Currency from 'components/currency';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import { useCheckoutState } from '../../checkout-provider';
import { useCheckoutLoadingState } from '../../hooks';

export const GrandTotalText = () => {
  const [{ tipLoading, totals }] = useCheckoutState();
  const { isOrderPriceLoading } = useCheckoutLoadingState();

  if (tipLoading) {
    return <Typography style={styles.totalText}>{t('loading')}</Typography>;
  }

  if (isOrderPriceLoading) {
    return <Skeleton style={styles.grandTotalSkeleton} />;
  }

  return (
    <Typography style={styles.totalText}>
      {t('total') + ': '}
      <Currency
        testID="grand-total"
        amount={totals?.grandTotal}
        isBold
        textProps={{
          color: primitive.$bbqBrown,
          fontSize: primitive.fontSizes.xl,
          style: { margin: 0, flexGrow: 0 },
        }}
      />
    </Typography>
  );
};

const styles = StyleSheet.create({
  totalText: {
    fontSize: primitive.fontSizes.xl,
    color: primitive.$bbqBrown,
    fontFamily: primitive.fontFamily.$headers,
  },
  grandTotalSkeleton: {
    height: 16,
    width: 120,
    alignSelf: 'center',
    color: primitive.$greyFour,
    marginBottom: 12,
    borderRadius: 100,
  },
});
